import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import getAggregatedFarmData from '@service/actions/getAggregatedFarmData';
import getFarmMiner from '@service/actions/getFarmMiner';
import { SET_BROWSER_PERIOD } from '@service/constant';
import { rootBrowserGraph } from '@service/reducers/browserStatsReducer';
import { rootFarmGraph } from '@service/reducers/farmGraphReducer';
import { rootUser } from '@service/reducers/userReducer';

import GraphComponent from '@shared/Graph/GraphComponent/GraphComponent';
import { Span } from '@shared/Graph/Tabs';

export function MinerCard() {
  const { t } = useTranslation();
  const [selectPeriod, setSelectPeriod] = useState(Span.Day);
  const dispatch = useDispatch();
  const store = useSelector((store: { user: rootUser; browserGraph: rootBrowserGraph }) => store);
  const period = useSelector((store: { browserGraph: rootBrowserGraph }) => ({
    start: store.browserGraph.period_start,
    end: store.browserGraph.period_end,
  }));
  const onPeriodChange = useCallback(
    (period: { period_start: string; period_end: string }) => {
      dispatch({
        type: SET_BROWSER_PERIOD,
        ...period,
      });
    },
    [dispatch]
  );
  useEffect(() => {
    store.user.id !== 0 &&
      dispatch(
        getFarmMiner(selectPeriod, store.user.id, store.browserGraph.period_start, store.browserGraph.period_end)
      );
    store.user.id !== 0 &&
      dispatch(
        getAggregatedFarmData(
          selectPeriod,
          store.user.id,
          store.browserGraph.period_start,
          store.browserGraph.period_end
        )
      );
  }, [dispatch, selectPeriod, store.user.id, store.browserGraph.period_start, store.browserGraph.period_end]);
  const data = useSelector((store: { farmGraph: rootFarmGraph }) => store.farmGraph.purchase_data);

  return (
    <GraphComponent
      id="miner"
      onPeriodChange={onPeriodChange}
      period={period}
      type={'value'}
      onSpanChanged={setSelectPeriod}
      span={selectPeriod}
      title={t('Active Miners')}
      data={data}
      // tooltip={t('ActiveMiners.tooltip')}
    />
  );
}
